export interface NavItem {
  path: string
  labelKey: string
  icon?: string
  descKey?: string
}

/**
 * Fonte única de verdade para os itens de navegação principal.
 * Consumido em: App.tsx (header desktop), MobileHeader.tsx, Home.tsx (button grid).
 */
export const NAV_ITEMS: NavItem[] = [
  { path: '/',                labelKey: 'nav.home' },
  { path: '/projects',        labelKey: 'nav.projects',       icon: '📱', descKey: 'home.btn.projectsDesc' },  
  { path: '/about',           labelKey: 'nav.about',          icon: '👤', descKey: 'home.btn.aboutDesc' },
  { path: '/libraries',       labelKey: 'nav.libraries',      icon: '📚', descKey: 'home.btn.librariesDesc' },
]

/** Itens exibidos no header desktop e menu mobile (exclui Home, que é o logo) */
export const HEADER_NAV_ITEMS = NAV_ITEMS.filter(item => item.path !== '/')

/** Itens exibidos no grid de botões da Home page */
export const HOME_BUTTON_ITEMS = NAV_ITEMS.filter(item => item.path !== '/')
